import * as Preact from "preact"
import PixiRenderer from "@frog/source/views/app/renderers/PixiRenderer.view.js"
import Navigation from "@frog/source/models/Navigation.js"
import "@frog/source/views/app/stage/Stage.view.less"

import sizes from "@frog/source/data/sizes.js"

export default class Stage {
    render() {
        return (
            <div class="Stage" isPixelated={sizes.canvas.isPixelated} isDone={Navigation.state.modal != undefined}>
                <PixiRenderer viewmodels={convert(StageViewModel(this.props.stage))}/>
                <Background/>
            </div>
        )
    }
}

function Background() {
    return
    if(Index.game.encounter.images == undefined) {
        return
    }
    return (
        <div class="Background">
            <div class="Image" style={{
                "background-image": "url(" + Index.game.encounter.images.background + ")",
            }}/>
        </div>
    )
}

// VIEW MODELS //

import Index from "@frog/source/models/App.js"
import Director from "@frog/source/models/juice/Director.js"

import pixel from "@frog/source/views/app/stage/pixel.js"
import Geometry from "@frog/source/utility/Geometry.js"
import Keyset from "@frog/source/utility/Keyset.js"

import WorldTerrain from "@frog/source/views/app/stage/WorldTerrain.view.js"
import Units from "@frog/source/views/app/stage/Units.view.js"
import ActionArrowLayer from "@frog/source/views/app/stage/ActionArrowLayer.view.js"
import ActionRangeLayer from "@frog/source/views/app/stage/ActionRangeLayer.view.js"
import Particles from "@frog/source/views/app/stage/Particles.view.js"

function convert(gross) {
    const viewmodels = {} // must be flat, must be key'd.

    let queue = [gross.entities]
    while(queue.length > 0)  {
        const viewmodel = queue.pop()
        if(viewmodel instanceof Array) {
            queue = queue.concat(viewmodel)
            continue
        }
        if(viewmodel == undefined) {
            continue
        }

        if(viewmodel.key == undefined) {
            continue
        }

        if(viewmodels[viewmodel.key] != undefined) {
            console.log("Overwriting", viewmodel, viewmodels[viewmodel.key])
        }
        viewmodels[viewmodel.key] = viewmodel
    }

    window.viewmodels = viewmodels

    return viewmodels
}

function StageViewModel(stage) {
    const view = {
        "entities": [
            // WorldTerrain(stage),
            Units(stage),
            ActionRangeLayer(stage),
            ActionArrowLayer(stage),
            Particles(stage),
            // Cursor(stage), // DEBUG
            Camera(stage.camera || Index.game.encounter.selection.camera),
            WinTiles(stage),
            Environment(),
            Fences(),
        ],
    }
    // window.frog = window.frog || {}
    // window.frog.view = view
    return view
}

const FENCE_IMAGES = {
    "left": require("@frog/source/images/ld47/[All levels] Fence _left.png"),
    "right": require("@frog/source/images/ld47/[All levels] Fence _right.png"),
}
const FENCE_LAYERS = {
    "left": "edge-block-south",
    "right": "edge-block-east",
}
function Fences() {
    if(Index.game.encounter.images != undefined
    && Index.game.encounter.images.fences != undefined) {
        return Index.game.encounter.images.fences.map((fence, index) => {
            return {
                "key": "world/fences/" + index,
                "image": FENCE_IMAGES[fence.direction],
                "position": pixel(FENCE_LAYERS[fence.direction], {
                    "x": fence.position.x,
                    "y": fence.position.y,
                    "z": fence.position.z - 0.1,
                }),
            }
            // {
            //     "key": "building",
            //     "image": Index.game.encounter.images.building,
            //     "anchor": {"x": 0, "y": 0},
            //     "position": {
            //         "x": Index.game.encounter.selection.camera.position.x * -1,
            //         "y": Index.game.encounter.selection.camera.position.y * -1,
            //         "stack": 0,
            //     },
            // })
        })
    }
}

function Environment() {
    const views = []
    if(Index.game.encounter.images != undefined) {
        views.push({
            "key": "building",
            "image": Index.game.encounter.images.building,
            "anchor": {"x": 0, "y": 0},
            "position": {
                "x": Index.game.encounter.selection.camera.position.x * -1,
                "y": Index.game.encounter.selection.camera.position.y * -1,
                "stack": 0,
            },
        })
        views.push({
            "key": "background",
            "image": Index.game.encounter.images.background,
            "anchor": {"x": 0, "y": 0},
            "position": {
                "x": Index.game.encounter.selection.camera.position.x * -1,
                "y": Index.game.encounter.selection.camera.position.y * -1,
                "stack": -10,
            },
            "blur": 10,
        })
        if(Index.game.encounter.images.foregroundfences != undefined) {
            views.push({
                "key": "foregroundfences",
                "image": Index.game.encounter.images.foregroundfences,
                "anchor": {"x": 0, "y": 0},
                "position": {
                    "x": Index.game.encounter.selection.camera.position.x * -1,
                    "y": Index.game.encounter.selection.camera.position.y * -1,
                    "stack": 100000,
                },
            })
        }
        if(Index.game.encounter.images.backgroundfences != undefined) {
            views.push({
                "key": "backgroundfences",
                "image": Index.game.encounter.images.backgroundfences,
                "anchor": {"x": 0, "y": 0},
                "position": {
                    "x": Index.game.encounter.selection.camera.position.x * -1,
                    "y": Index.game.encounter.selection.camera.position.y * -1,
                    "stack": -1,
                },
            })
        }
    }
    return views
    return [
        // {
        //     "key": "building",
        //     "image": require("@frog/source/images/ld47/building-sides.png"),
        //     "position":  pixel("building-sides", {
        //         "x": 5,
        //         "y": 5,
        //         "z": window.anchor || -4.28,
        //     }),
        // },
        // {
        //     "key": "background",
        //     "image": require("@frog/source/images/ld47/background.png"),
        //     "anchor": {"x": 0, "y": 0},
        //     "position": {
        //         "x": 0,
        //         "y": 0,
        //         "stack": 0,
        //     },
        // }
    ]
}

function Camera(camera) {
    return {
        "key": "camera",
        "position": camera.position
    }
}

function Cursor(stage) {
    if(Index.game.encounter.selection.position.z == 0) {
        return
    }
    return {
        "key": "cursor",
        "image": require("@frog/source/images/dot.png"),
        "position": pixel("cursor", {
            "x": Index.game.encounter.selection.position.x - 0.5,
            "y": Index.game.encounter.selection.position.y - 0.5,
            "z": Index.game.encounter.selection.position.z,
        }),
    }
}

const DEFAULT_EXIT_IMAGES = [
    require("@frog/source/images/ld47/[All levels] Exit tile1.png"),
    require("@frog/source/images/ld47/[All levels] Exit tile2.png"),
    require("@frog/source/images/ld47/[All levels] Exit tile3.png"),
    require("@frog/source/images/ld47/[All levels] Exit tile4.png"),
]

const ACTION_RANGE_COLORS = {
    "invoke skill": 0xffb2a1,
    "move": 0x7471d5,
}
ACTION_RANGE_COLORS["move through"] = ACTION_RANGE_COLORS["move"]
ACTION_RANGE_COLORS["wait-for-move"] = ACTION_RANGE_COLORS["move"]
ACTION_RANGE_COLORS["wait-for-invoke-skill"] = ACTION_RANGE_COLORS["move"]

import timer from "@frog/source/views/app/stage/timer.js"
function WinTiles(stage) {
    if(stage.victory != undefined
    && stage.victory.condition == "escape") {
        let images = DEFAULT_EXIT_IMAGES
        if(Index.game.encounter.images != undefined
        && Index.game.encounter.images.exits != undefined) {
            images = Index.game.encounter.images.exits
        }
        return stage.victory.positions.map((position, index) => {
            let tint = undefined
            const actionType = getActionableTileType(position, stage)
            if(actionType != undefined) {
                tint = ACTION_RANGE_COLORS[actionType]
            }
            return {
                "key": "stage/victory/escape/" + Geometry.toString(position),
                // "image": require("@frog/source/images/redyellow.range.png"),
                "image": images[Math.floor((Math.sin((index * 100) + timer.time * 5) + 1) * 2)],
                "position": pixel("escapezone", position),
                "tint": tint
            }
        })
    }
}

import {getActionableTileType} from "@frog/source/views/app/stage/ActionRangeLayer.view.js"

// function InfluenceMapDebug(stage) {
//     const views = []
//     return // THIS IS OBSOLETE WITH THE DEPRECATION OF WORLD.BLOCKS
//     stage.world.blocks.forEach((block) => {
//         if(block.position.z != 0
//         || Index.game.encounter.selection.hoveredAction == undefined) {
//         // || Index.game.encounter.stage.units[1].actionmap[block.position.x + "x" + block.position.y + "x" + (block.position.z+1)] == undefined) {
//             return
//         }
//         // const number = Index.game.encounter.stage.units[1].actionmap[block.position.x + "x" + block.position.y + "x" + (block.position.z+1)][0].score
//         // const number = Index.game.encounter.stage.units[1].bestAction.influenceMap[block.position.x + "x" + block.position.y + "x" + (block.position.z+1)]
//         const number = Index.game.encounter.selection.hoveredAction.omegastage.units[1].bestAction.influenceMap[block.position.x + "x" + block.position.y + "x" + (block.position.z+1)]
//         // const number = Index.game.encounter.selection.hoveredAction.omegastage.units[1].actionmap[block.position.x + "x" + block.position.y + "x" + (block.position.z+1)][0].score
//         views.push({
//             // NEEDS KEY OR ELSE WON'T BE RENDERED
//             "type": "Text",
//             "position": pixel("influence", {
//                 "x": block.position.x-0.5,
//                 "y": block.position.y-0.5,
//                 "z": block.position.z+1,
//             }),
//             "text": (number || 0).toFixed(1),
//         })
//         views.push({
//             // NEEDS KEY OR ELSE WON'T BE RENDERED
//             "image": require("@frog/source/images/red.range.png"),
//             "position": pixel("influence", {
//                 "x": block.position.x,
//                 "y": block.position.y,
//                 "z": block.position.z+1,
//             }),
//             "opacity": (number || 0) / 200
//         })
//     })
//     return views
// }
